import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { appApiResources } from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class GetAllLanguageService {

  constructor(private http: HttpClient) { }

  async getAllLanguage() {
    try {
      let response = await this.http
        .get(`${appApiResources.getLanguage}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }

  getAllLanguageSub() {
    return this.http.get(`${appApiResources.getLanguage}`)

  }
}
